﻿import { useState, useEffect } from 'react';
import { products, tempLock } from '../Endpoints';
import { parseDate } from '../../../../../Resources/Scripts/_Shared/parseDate';
import moment from "moment";

export const useProductAvailability = (isAccessDevice, product, startDate, bookingFlowContext) => {
  const costLang = bookingFlowContext.localization.global.cost;
  const [productAvailability, useProductAvailability] = useState(null);
  const [productAvailabilityCount, useProductAvailabilityCount] = useState(null);
  const [productAvailableFrom, useProductAvailableFrom] = useState(null);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    let isSubscribed = true;
    const getProductAvailability = async () => {

      if (product.Id === '00000000-0000-0000-0000-000000000000' || (!isAccessDevice && startDate === null))
        return;
      setPending(true);

      const productPaymentOptions = [];
      if (product.MonthlyPrice && parseFloat(product.MonthlyPrice) > 0)
        productPaymentOptions.push({ text: costLang.monthly, value: 'MONTHLY', currency: product.Currency, optionPrice: product.MonthlyPrice, id: '5b6cc789-365f-4483-848a-ab429c30ddaf' })
      if (product.QuarterlyPrice && parseFloat(product.QuarterlyPrice) > 0)
        productPaymentOptions.push({ text: costLang.quarterly, value: 'QUARTERLY', currency: product.Currency, optionPrice: product.QuarterlyPrice, id: '667cd478-0b04-4df5-bd9c-c89cac22d2dd' })
      if (product.HalfYearlyPrice && parseFloat(product.HalfYearlyPrice) > 0)
        productPaymentOptions.push({ text: costLang.half_yearly, value: 'HALF_YEARLY', currency: product.Currency, optionPrice: product.HalfYearlyPrice, id: '557201b3-241b-4663-8e33-4f44f1ea9fbd' })
      if (product.AnnualPrice && parseFloat(product.AnnualPrice) > 0)
        productPaymentOptions.push({ text: costLang.annually, value: 'ANNUALLY', currency: product.Currency, optionPrice: product.AnnualPrice, id: '11261993-13f1-409d-ac9f-7d6a6e9039e3' })

      if (product.BillingFrequencyOptions) {
        const filteredProductPaymentOptions = productPaymentOptions.filter(paymentOption => product.BillingFrequencyOptions.includes(paymentOption.value));
        setPaymentOptions(filteredProductPaymentOptions);
      } else {
        setPaymentOptions(productPaymentOptions);
      }

      let isReservedProduct = product.Type === 'RESERVED';
      const productAvailability = await products.getAvailability({ bookingController: bookingFlowContext.episerver.bookingController, pmcId: product.Id, startDate }, bookingFlowContext.useMockedData);
      let availableSpotsCount = productAvailability.status === 200 ? productAvailability.body.Availability ?? 0 : 0;

      //if (!isAccessDevice) {
      //  const startSellingDate = parseDate(product.StartSellingDate, 'sv', 'L')
      //  const compareStartDate = parseDate(startDate, 'sv', 'L');

      //  if (moment(compareStartDate).isBefore(startSellingDate, 'day')) {
      //    availableSpotsCount = 0;
      //  }
      //}
      let availableFrom = productAvailability.body?.AvailableFrom ? {
        until: new Date(moment(productAvailability.body?.AvailableFrom).subtract(12, 'hours')).toISOString(),
        from: new Date(moment(productAvailability.body?.AvailableFrom).add(12, 'hours')).toISOString()
      } : null;

      const productMaxSpotOnline = parseFloat(product.MaxSpotOnline ?? 10000);
      if (productMaxSpotOnline < availableSpotsCount)
        availableSpotsCount = productMaxSpotOnline;

      if ((isReservedProduct && isSubscribed) || (isAccessDevice && isSubscribed)) {
        const availableSpots = await products.getParkingSpaceAvailability({ bookingController: bookingFlowContext.episerver.bookingController, pmcId: product.Id, startDate, onlyAvailableSpaces: false }, bookingFlowContext.useMockedData);
        if (availableSpots.status === 200 && isSubscribed && availableSpotsCount > 0 && !availableFrom && availableSpots.body.some(spot => spot.ParkingSpaceStatus === 'AVAILABLE')) {
          if (isAccessDevice && availableSpots.body) {
            availableSpots.body = availableSpots.body.filter(spot => spot.ParkingSpaceStatus === 'NOT_AVAILABLE');
            availableSpots.body.unshift({ ParkingSpace: { Name: "N/A" } });
          }
          useProductAvailability(availableSpots.body.filter(spot => (spot.ParkingSpaceStatus === 'AVAILABLE' || spot.LastBookingEnds)) ?? []),
            useProductAvailabilityCount(availableSpotsCount);
        } else {
          useProductAvailability([]), useProductAvailabilityCount(0);

          if (availableSpots.body && availableSpots.body.some(spot => spot.LastBookingEnds)) {
            let lastBookingEnds = productAvailability.body?.AvailableFrom || availableSpots.body.find(spot => spot.LastBookingEnds)?.LastBookingEnds;
            availableSpots.body.forEach(spot => {
              if (spot.LastBookingEnds && moment(spot.LastBookingEnds).isBefore(lastBookingEnds)) lastBookingEnds = spot.LastBookingEnds;
            });
            availableFrom = {
              until: new Date(moment(lastBookingEnds).subtract(12, 'hours')).toISOString(),
              from: new Date(moment(lastBookingEnds).add(12, 'hours')).toISOString()
            };
          }
          useProductAvailableFrom(availableFrom);
        }
        setPending(false);
      }
      else if (!isReservedProduct && availableSpotsCount > 0 && isSubscribed && !isAccessDevice) {
        let i = 0;
        const arr = [];
        while (i < availableSpotsCount) {
          arr.push({ ParkingSpace: { Name: '-', Uid: i } }), i++;
        }

        useProductAvailability(arr), useProductAvailabilityCount(arr.length);
        setPending(false);
			}
      else if (isSubscribed) {
        useProductAvailability([]), useProductAvailabilityCount(0), useProductAvailableFrom(availableFrom);
        setPending(false);
      }
    }

    getProductAvailability();
    return () => isSubscribed = false;
  }, [product, startDate])

  return [productAvailability, productAvailabilityCount, paymentOptions, pending, productAvailableFrom];
}
